import Service, { getCallApiFunction } from '../service'

// 幫助中心共用型別（後端 controller_model/help_center.go，回應 key 已轉 camelCase）
export interface HelpCollectionItem {
  id: number
  parentId: number
  name: string
  description: string
  iconUrl: string
  slug: string
  articleCount: number
}

export interface HelpArticleSummary {
  id: number
  collectionId: number
  title: string
  slug: string
  summary: string
  updatedAt: string
}

export interface HelpBreadcrumb {
  id: number
  name: string
  slug: string
}

/** 站點由請求國碼決定（後端 sutil.GetLaunchCountry）；SSR 沒有使用者位置，由呼叫端依語系 / query 指定 */
export const helpCountryHeader = (countryCode: string) => ({ 'Tutor-Header-CountryCode': countryCode })

export interface IParams {
  id: number
  countryCode: string
}

export interface FetchHelpArticleResponse {
  id: number
  collectionId: number
  title: string
  slug: string
  summary: string
  /** 後台編輯器產生的 HTML，渲染前一定要 sanitize */
  content: string
  showToc: boolean
  updatedAt: string
  /** 由上到下，最後一個是文章所在分類 */
  breadcrumbs: HelpBreadcrumb[]
  relatedArticles: HelpArticleSummary[]
}

// 幫助中心文章頁
class FetchHelpArticleApi extends Service {
  constructor({ id, countryCode }: IParams) {
    super()
    this.name = 'FETCH_HELP_ARTICLE'

    this.config = {
      url: `/v1/help/articles/${id}`,
      method: 'GET',
      headers: helpCountryHeader(countryCode),
    }
  }
}

export const fetchHelpArticle = (params: IParams): Promise<FetchHelpArticleResponse> => getCallApiFunction(new FetchHelpArticleApi(params))
